import React from "react";
import clsx from "clsx";
import {
  Card,
  CardContent,
  CardMedia,
  Grid,
  Hidden,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import radioImgXS from "assets/images/podcast200x200.jpg";
import radioImg from "assets/images/podcast200x200.jpg";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import ToolTipKeys from "constants/ToolTipKeys";
import { DeleteButton, HeartButton } from "modules3/components";
import MoreAction from "common/ui/moreAction";
import container from "./ListItemList.container";

const useStyles = makeStyles((theme) => ({
  listItem: {
    margin: "0px 10px",
    position: "relative",
    border: "1px solid",
    borderColor: theme.palette.borderColor,
    borderBottomColor: theme.palette.borderColor,
    background: theme.palette.paperColor,
    color: theme.palette.textColor,
    fontFamily: "Arial",
    width: "100%",
    maxWidth: "100%",
    marginBottom: theme.spacing(1),
    borderRadius: 7,
    cursor: "pointer",
    display: "flex",
    justifyContent: "space-between",
    boxShadow: "0 4px 15px 0px rgba(248, 71, 62, 0.05)",
    "&:hover": {
      background: theme.palette.hoverColorItem,
    },
    "&:hover $titleText": {
      color: theme.palette.pink,
    },
    "&:hover $outerCircle": {
      background: `-webkit-radial-gradient(50% 0, circle, rgba(0,0,0,0) 22px, ${theme.palette.hoverColorItem} 23px)`,
    },
    "&:hover $trendingBoxOverlay": {
      opacity: 1,
    },
    "&:hover $actionOptions": {
      opacity: 1,
    },
    [theme.breakpoints.down("xs")]: {
      maxWidth: "100%",
      maxHeight: 100,
      justifyContent: "center",
      textAlign: "center",
    },
  },
  topSongListLeft: {
    display: "flex",
    float: "left",
    width: "70%",
    overflow: "hidden",
    [theme.breakpoints.down("xs")]: {
      width: "90%",
    },
  },
  cardWrapper: {
    minWidth: 75,
    minHeight: 50,
    width: 130,
    height: 115,
    display: "inline-block",
    position: "relative",
  },
  cardImage: {
    // width: 165,
    width: 139,
    height: 115,
    borderRadius: 0,
    objectFit: "cover",
  },
  trendingBoxOverlay: {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    opacity: 0,
    width: 165,
    borderRadius: 5,
    display: "block",
    position: "absolute",
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    // backgroundImage: '-webkit-linear-gradient( 90deg, rgb(22, 26, 46) 0%, rgb(237, 63, 179) 0%, rgb(248, 71, 62) 0%, rgba(254, 121, 69, 0.4) 100%)',
    transition: "all 0.6s ease 0s",
  },
  iconPlay: {
    width: 35,
    height: 35,
    fill: "#ff0066",
    marginTop: 20,
  },
  playIcon: {
    width: 35,
    height: 35,
    fill: "#fff",
    // marginTop: 35,
    background: "#ff0066",
    borderRadius: "50%",
  },
  textWrapper: {
    flex: "1 1 0%",
    width: "50%",
    minWidth: 0,
    lineHeight: "25px",
    display: "flex",
    paddingLeft: 10,
    marginLeft: 40,
    flexDirection: "column",
    justifyContent: "center",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  titleText: {
    fontSize: 16,
    textAlign: "left",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  subtitle: {
    fontSize: 14,
    textAlign: "left",
    color: theme.palette.textColor2,
    display: "flex",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  topSongListRight: {
    float: "left",
    width: "30%",
    display: "flex",
    justifyContent: "center",
    // paddingTop: '16px',
    [theme.breakpoints.down("xs")]: {
      width: "10%",
    },
  },
  buttonWrapper: {
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    transition: "all .2s ease-in-out",
  },
  actionOptions: {
    opacity: 0,
    // display: 'flex',
    whiteSpace: "nowrap",
    transition: "all .2s ease-in-out",
    "&:hover": {
      color: theme.palette.black,
    },
    [theme.breakpoints.down("xs")]: {
      opacity: 1,
    },
  },
  showOption: {
    opacity: 1,
    whiteSpace: "nowrap",
    transition: "all .2s ease-in-out",
  },
  iconButton: {
    width: 30,
    height: 30,
    padding: 0,
    marginRight: 10,
    display: "inline-block",
  },
  icon: {
    display: "inline-block",
    color: "rgb(37, 37, 37)",
    fill: "rgb(176, 176, 176)",
    height: 20,
    width: 20,
    userSelect: "none",
    transition: "all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms",
    "&:hover": {
      color: theme.palette.iconHover,
      fill: theme.palette.iconHover,
    },
  },
  defaultImageTitle: {
    top: 0,
    width: 115,
    fontSize: 13,
    color: "#fff",
    padding: "0 5px",
    position: "absolute",
    display: "block",
    textAlign: "center",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  defaultTitle: {
    width: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "block",
  },
  playerIcon: {
    position: "absolute",
    padding: "52px 0px 0px 107px",
    marginTop: -12,
    marginLeft: 16,
    [theme.breakpoints.down("xs")]: {
      marginTop: -22,
    },
  },
  outerCircle: {
    width: 118,
    height: 35,
    zIndex: 999,
    marginTop: 40,
    marginLeft: 98,
    position: "absolute",
    transform: "rotate(270deg)",
    background: `-webkit-radial-gradient(50% 0, circle, rgba(0,0,0,0) 22px, ${theme.palette.outerCircle} 23px)`,
    // backgroundPosition: 'bottom left, bottom right, top right, top left',
    backgroundSize: "100%",
    backgroundRepeat: "no-repeat",
    // boxShadow: '0 -5px 8px -7px #333',
    [theme.breakpoints.down("xs")]: {
      marginTop: 30,
    },
  },
  locator: {
    marginTop: 9,
    marginLeft: -15,
    border: "3px solid #ff0066",
    position: "absolute",
    borderRadius: "100%",
    background: "#ff0066",
  },
}));

const ListItemList = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const matchesXS = useMediaQuery(theme.breakpoints.down("xs"));
  const style = {
    height: 20,
    width: 20,
  };

  const {
    podcastid,
    userhistoryPodcastState: { heartedPodcastIds },
    tooltipState: { podcastCurrentEntry },
    onListItemClick,
    onFavouriteClick,
    onDeleteClick,
    onPodcastMoreToolTip,
  } = props;
  const [openAction, setOpenAction] = React.useState({});

  const isHearted = heartedPodcastIds
    ? heartedPodcastIds.some((podcastId) => podcastId === podcastid)
    : false;

  const onMediaFallback = (event) => {
    if (matchesXS) {
      event.target.src = radioImgXS;
    } else {
      event.target.src = radioImg;
    }
  };

  const onClickHandler = () => {
    onListItemClick(props.sectionTab, podcastid);
  };

  const handleClose = () => {
    setOpenAction({});
  };

  const onMoreVertHandler = (event) => {
    event.stopPropagation();
    event.preventDefault();
    setOpenAction({
      [podcastid]: true,
    });
    onPodcastMoreToolTip(ToolTipKeys.PodCastMoreAction, null, podcastid);
  };

  const onDeleteClickHandler = (event) => {
    event.stopPropagation();
    event.preventDefault();
    onDeleteClick(podcastid);
  };

  const onFavouriteClickHandler = (event) => {
    event.stopPropagation();
    event.preventDefault();
    onFavouriteClick(podcastid);
  };

  return (
    <Card
      className={clsx("list-item", classes.listItem)}
      raised={false}
      onClick={onClickHandler}
    >
      <div className={clsx("topSongListLeft", classes.topSongListLeft)}>
        <div className={classes.cardWrapper}>
          <CardMedia
            alt={props.title}
            component="img"
            className={classes.cardImage}
            src={props.image}
            onError={onMediaFallback}
          />
          <div
            className={clsx("trendingBoxOverlay", classes.trendingBoxOverlay)}
          />
        </div>
        <div className={clsx("outerCircle", classes.outerCircle)} />
        <CardContent className={classes.playerIcon}>
          <Grid container justify="center">
            <PlayArrowIcon className={classes.playIcon} />
          </Grid>
        </CardContent>
        <div className={classes.textWrapper}>
          <div className={clsx("titleText", classes.titleText)}>
            {props.title}
          </div>
          {/*<div className={clsx('subTitle', classes.subtitle)}>
            {props.subtitle}
          </div>*/}
          {/*<div className={clsx('subTitle', classes.subtitle)}>
            <div>
              <span className={clsx('locator', classes.locator)} />
              {props.subtitle}
            </div>
            <div style={{ marginLeft: 30 }}>
              <span className={clsx('locator', classes.locator)} />
              {props.data.author}
            </div>
          </div>*/}
        </div>
      </div>
      <div className={clsx("topSongListRight", classes.topSongListRight)}>
        <div className={classes.buttonWrapper}>
          <Hidden mdUp>
            <MoreVertIcon
              style={{ textAlign: "right" }}
              onClick={onMoreVertHandler}
            />
          </Hidden>
          <Hidden smDown>
            <div style={{ display: "flex" }}>
              {props.editable && (
                <div className={classes.actionOptions}>
                  <DeleteButton onDeleteClickHandler={onDeleteClickHandler} />
                </div>
              )}
              {!props.hearted && (
                <div
                  className={clsx(classes.actionOptions, {
                    [classes.showOption]: isHearted,
                  })}
                >
                  <HeartButton
                    style={style}
                    name={"Podcast"}
                    isHearted={isHearted}
                    onFavouriteClickHandler={onFavouriteClickHandler}
                  />
                </div>
              )}
            </div>
          </Hidden>
        </div>
      </div>
      {openAction[podcastid] &&
        podcastCurrentEntry.key === ToolTipKeys.PodCastMoreAction && (
          <MoreAction
            toolTipKey={ToolTipKeys.PodCastMoreAction}
            hearted={props.hearted}
            isHearted={isHearted}
            editable={props.editable}
            onPlayClick={onClickHandler}
            onDeleteClick={onDeleteClickHandler}
            onHeartClick={onFavouriteClickHandler}
            onHandleClose={handleClose}
          />
        )}
    </Card>
  );
};

export default container(ListItemList);
